var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "approval" },
    [
      _c(
        "div",
        { staticClass: "content" },
        [
          _c(
            "el-form",
            {
              ref: "formApproval",
              attrs: {
                size: "mini",
                model: _vm.approvalModel,
                "label-width": "100px"
              },
              nativeOn: {
                submit: function($event) {
                  $event.preventDefault()
                }
              }
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "审批名称",
                    prop: "approvalName",
                    rules: _vm.rules.approvalName
                  }
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "300px" },
                    attrs: { placeholder: "请输入审批名称" },
                    model: {
                      value: _vm.approvalModel.approvalName,
                      callback: function($$v) {
                        _vm.$set(_vm.approvalModel, "approvalName", $$v)
                      },
                      expression: "approvalModel.approvalName"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "审批类型" } },
                [
                  _c(
                    "el-radio",
                    {
                      attrs: { label: 1 },
                      model: {
                        value: _vm.approvalModel.approvalType,
                        callback: function($$v) {
                          _vm.$set(_vm.approvalModel, "approvalType", $$v)
                        },
                        expression: "approvalModel.approvalType"
                      }
                    },
                    [_vm._v("顺序审批（按先后顺序审批）")]
                  ),
                  _c(
                    "el-radio",
                    {
                      attrs: { label: 0 },
                      model: {
                        value: _vm.approvalModel.approvalType,
                        callback: function($$v) {
                          _vm.$set(_vm.approvalModel, "approvalType", $$v)
                        },
                        expression: "approvalModel.approvalType"
                      }
                    },
                    [_vm._v("会审 （无顺序，全员通过则通过）")]
                  )
                ],
                1
              ),
              _vm.flowType
                ? _c(
                    "el-form-item",
                    [
                      _c(
                        "span",
                        { attrs: { slot: "label" }, slot: "label" },
                        [
                          _c("span", [_vm._v(" 审批复用 ")]),
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                effect: "light",
                                content: "",
                                placement: "top"
                              }
                            },
                            [
                              _c(
                                "div",
                                { attrs: { slot: "content" }, slot: "content" },
                                [
                                  _vm._v(
                                    "\n              开启后，如果当前审批流程中的审批人已参与了文件发起审批，则不需要再进行用印审批。\n            "
                                  )
                                ]
                              ),
                              _c("i", {
                                staticClass: "el-icon-question",
                                staticStyle: {
                                  "font-size": "16px",
                                  color: "#a1a1a1",
                                  cursor: "pointer"
                                }
                              })
                            ]
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-radio",
                        {
                          attrs: { label: 1 },
                          model: {
                            value: _vm.approvalModel.useFileAuditFlag,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.approvalModel,
                                "useFileAuditFlag",
                                $$v
                              )
                            },
                            expression: "approvalModel.useFileAuditFlag"
                          }
                        },
                        [_vm._v("开")]
                      ),
                      _c(
                        "el-radio",
                        {
                          attrs: { label: 0 },
                          model: {
                            value: _vm.approvalModel.useFileAuditFlag,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.approvalModel,
                                "useFileAuditFlag",
                                $$v
                              )
                            },
                            expression: "approvalModel.useFileAuditFlag"
                          }
                        },
                        [_vm._v("关")]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "审批流程",
                    prop: "approvalFlow",
                    rules: _vm.rules.approvalFlow
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: { display: "inline", position: "relative" }
                    },
                    [
                      _vm._l(_vm.flows, function(v, index) {
                        return _c(
                          "flow",
                          {
                            key: index,
                            attrs: { model: v, hiddenArrow: _vm.hiddenArrow },
                            on: {
                              handleClickFlowRemove: _vm.handleClickFlowRemove
                            }
                          },
                          [
                            _c(
                              "div",
                              { attrs: { slot: "username" }, slot: "username" },
                              [
                                _c(
                                  "span",
                                  { staticStyle: { color: "#aaaaaa" } },
                                  [_vm._v(_vm._s(v.partyName))]
                                )
                              ]
                            ),
                            _c(
                              "div",
                              { attrs: { slot: "update" }, slot: "update" },
                              [
                                _c(
                                  "a",
                                  {
                                    staticClass: "custom-a",
                                    attrs: { href: "javascript:void(0);" },
                                    on: {
                                      click: function($event) {
                                        return _vm.handleClickFlowUpdate(v)
                                      }
                                    }
                                  },
                                  [_vm._v("修改")]
                                )
                              ]
                            )
                          ]
                        )
                      }),
                      _c("plus", {
                        on: { handleClickFlowPlus: _vm.handleClickFlowPlus }
                      })
                    ],
                    2
                  )
                ]
              ),
              !_vm.flowType
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "抄送人",
                        prop: "copyToName",
                        rules: _vm.rules.copyToName
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "inline",
                            position: "relative"
                          }
                        },
                        [
                          _vm._l(_vm.copyToMembers, function(v, index) {
                            return _c(
                              "flow",
                              {
                                key: index,
                                attrs: { model: v, hiddenArrow: false },
                                on: {
                                  handleClickFlowRemove:
                                    _vm.handleClickCopyRemove
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    attrs: { slot: "username" },
                                    slot: "username"
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticStyle: { color: "#aaaaaa" } },
                                      [_vm._v(_vm._s(v.partyName))]
                                    )
                                  ]
                                ),
                                _c(
                                  "div",
                                  { attrs: { slot: "update" }, slot: "update" },
                                  [
                                    _c(
                                      "a",
                                      {
                                        staticClass: "custom-a",
                                        attrs: { href: "javascript:void(0);" },
                                        on: {
                                          click: function($event) {
                                            return _vm.handleClickCopyUpdate(v)
                                          }
                                        }
                                      },
                                      [_vm._v("修改")]
                                    )
                                  ]
                                )
                              ]
                            )
                          }),
                          _c("plus", {
                            on: { handleClickFlowPlus: _vm.handleClickCopyPlus }
                          })
                        ],
                        2
                      )
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "footer", staticStyle: { "text-align": "right" } },
        [
          _c(
            "el-button",
            { attrs: { size: "mini" }, on: { click: _vm.approvalCancel } },
            [_vm._v("取消")]
          ),
          _c(
            "el-button",
            {
              staticStyle: { "margin-right": "50px" },
              attrs: { size: "mini", type: "danger" },
              on: { click: _vm.approvalOk }
            },
            [_vm._v("确定")]
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.addOrUpdateApprovalorTitle,
            visible: _vm.visibleDialogSelectApprovalor,
            width: "800px"
          },
          on: {
            "update:visible": function($event) {
              _vm.visibleDialogSelectApprovalor = $event
            }
          }
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c(
                  "div",
                  [
                    _c(
                      "el-radio",
                      {
                        attrs: { label: true },
                        model: {
                          value: _vm.approvalType,
                          callback: function($$v) {
                            _vm.approvalType = $$v
                          },
                          expression: "approvalType"
                        }
                      },
                      [_vm._v("固定成员")]
                    ),
                    _c(
                      "el-radio",
                      {
                        attrs: { label: false },
                        model: {
                          value: _vm.approvalType,
                          callback: function($$v) {
                            _vm.approvalType = $$v
                          },
                          expression: "approvalType"
                        }
                      },
                      [_vm._v("主管")]
                    )
                  ],
                  1
                ),
                _vm.approvalType
                  ? _c(
                      "section",
                      [
                        _c(
                          "el-form",
                          {
                            staticStyle: {
                              "margin-top": "20px",
                              "text-align": "right"
                            },
                            attrs: {
                              inline: true,
                              size: "small",
                              model: _vm.filterModel
                            }
                          },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "" } },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "150px" },
                                  attrs: {
                                    placeholder: "邮箱/手机号",
                                    clearable: ""
                                  },
                                  model: {
                                    value: _vm.filterModel.targetId,
                                    callback: function($$v) {
                                      _vm.$set(_vm.filterModel, "targetId", $$v)
                                    },
                                    expression: "filterModel.targetId"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              { attrs: { label: "" } },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "150px" },
                                  attrs: { placeholder: "名称", clearable: "" },
                                  model: {
                                    value: _vm.filterModel.corpUserName,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.filterModel,
                                        "corpUserName",
                                        $$v
                                      )
                                    },
                                    expression: "filterModel.corpUserName"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              { attrs: { label: "" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "150px" },
                                    attrs: { placeholder: "请选择部门" },
                                    model: {
                                      value: _vm.filterModel.corpGroupId,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.filterModel,
                                          "corpGroupId",
                                          $$v
                                        )
                                      },
                                      expression: "filterModel.corpGroupId"
                                    }
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: { label: "全部", value: "" }
                                    }),
                                    _vm._l(_vm.memberGroups, function(item, i) {
                                      return _c("el-option", {
                                        key: i,
                                        attrs: {
                                          label: item.groupName,
                                          value: item.corpGroupId
                                        }
                                      })
                                    })
                                  ],
                                  2
                                )
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              { staticStyle: { "margin-right": "0px" } },
                              [
                                _c(
                                  "el-button",
                                  {
                                    on: { click: _vm.handleClickSearchManager }
                                  },
                                  [_vm._v("查询")]
                                ),
                                _c(
                                  "el-button",
                                  { on: { click: _vm.approvalReset } },
                                  [_vm._v("重置")]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          {
                            staticClass: "custom-table-style",
                            staticStyle: { padding: "0px" },
                            attrs: { span: 24 }
                          },
                          [
                            _c(
                              "el-table",
                              {
                                staticStyle: {
                                  border: "1px solid #cbcbcb",
                                  "border-bottom": "0"
                                },
                                attrs: {
                                  data: _vm.tableSetManager,
                                  "tooltip-effect": "dark",
                                  "highlight-current-row": "",
                                  "cell-style": { cursor: "pointer" },
                                  "header-cell-style": {
                                    background: "#f9f9f9",
                                    color: "#333333",
                                    fontWeight: "500"
                                  }
                                },
                                on: { "row-click": _vm.handleClickRow }
                              },
                              [
                                _c("el-table-column", {
                                  attrs: {
                                    label: "邮箱/手机号",
                                    prop: "targetId",
                                    "show-overflow-tooltip": ""
                                  }
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    label: "名称",
                                    prop: "userName",
                                    "show-overflow-tooltip": ""
                                  }
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    label: "部门",
                                    prop: "groupNames",
                                    "show-overflow-tooltip": ""
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          {
                            staticClass: "page-flex-end",
                            staticStyle: {
                              padding: "30px 0",
                              position: "relative"
                            },
                            attrs: { span: 24 }
                          },
                          [
                            _c("el-pagination", {
                              attrs: {
                                "current-page": _vm.filterModel.itemPage,
                                "page-sizes": [10, 20, 50, 100],
                                "page-size": _vm.filterModel.pageSize,
                                layout: "sizes, prev, pager, next, total",
                                total: _vm.filterModel.pageTotal
                              },
                              on: {
                                "size-change": _vm.handleSizeChange,
                                "current-change": _vm.handleCurrentChange
                              }
                            }),
                            _c("el-go", {
                              attrs: {
                                "page-size": _vm.filterModel.pageSize,
                                total: _vm.filterModel.pageTotal
                              },
                              on: { "current-change": _vm.handleCurrentChange }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _c("section", [
                      _c(
                        "div",
                        { staticStyle: { margin: "20px 0" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { size: "mini", placeholder: "请选择" },
                              model: {
                                value: _vm.selectApprovalorManagerValue,
                                callback: function($$v) {
                                  _vm.selectApprovalorManagerValue = $$v
                                },
                                expression: "selectApprovalorManagerValue"
                              }
                            },
                            _vm._l(_vm.managerLevel, function(v, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: { value: v.value, label: v.label }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ])
              ])
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini" },
                  on: {
                    click: function($event) {
                      _vm.visibleDialogSelectApprovalor = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.handleSelectApprovalorOk()
                    }
                  }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "选择抄送人",
            visible: _vm.visibleDialogSelectCopy,
            width: "800px"
          },
          on: {
            "update:visible": function($event) {
              _vm.visibleDialogSelectCopy = $event
            }
          }
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c(
                  "section",
                  [
                    _c(
                      "el-form",
                      {
                        staticStyle: {
                          "margin-top": "20px",
                          "text-align": "right"
                        },
                        attrs: {
                          inline: true,
                          size: "small",
                          model: _vm.filterModel
                        }
                      },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "" } },
                          [
                            _c("el-input", {
                              staticStyle: { width: "150px" },
                              attrs: {
                                placeholder: "邮箱/手机号",
                                clearable: ""
                              },
                              model: {
                                value: _vm.filterModel.targetId,
                                callback: function($$v) {
                                  _vm.$set(_vm.filterModel, "targetId", $$v)
                                },
                                expression: "filterModel.targetId"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "" } },
                          [
                            _c("el-input", {
                              staticStyle: { width: "150px" },
                              attrs: { placeholder: "名称", clearable: "" },
                              model: {
                                value: _vm.filterModel.corpUserName,
                                callback: function($$v) {
                                  _vm.$set(_vm.filterModel, "corpUserName", $$v)
                                },
                                expression: "filterModel.corpUserName"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "" } },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "150px" },
                                attrs: { placeholder: "请选择部门" },
                                model: {
                                  value: _vm.filterModel.corpGroupId,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.filterModel,
                                      "corpGroupId",
                                      $$v
                                    )
                                  },
                                  expression: "filterModel.corpGroupId"
                                }
                              },
                              [
                                _c("el-option", {
                                  attrs: { label: "全部", value: "" }
                                }),
                                _vm._l(_vm.memberGroups, function(item, i) {
                                  return _c("el-option", {
                                    key: i,
                                    attrs: {
                                      label: item.groupName,
                                      value: item.corpGroupId
                                    }
                                  })
                                })
                              ],
                              2
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { staticStyle: { "margin-right": "0px" } },
                          [
                            _c(
                              "el-button",
                              { on: { click: _vm.handleClickSearchManager } },
                              [_vm._v("查询")]
                            ),
                            _c(
                              "el-button",
                              { on: { click: _vm.approvalReset } },
                              [_vm._v("重置")]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      {
                        staticClass: "custom-table-style",
                        staticStyle: { padding: "0px" },
                        attrs: { span: 24 }
                      },
                      [
                        _c(
                          "el-table",
                          {
                            staticStyle: {
                              border: "1px solid #cbcbcb",
                              "border-bottom": "0"
                            },
                            attrs: {
                              data: _vm.tableSetManager,
                              "tooltip-effect": "dark",
                              "highlight-current-row": "",
                              "cell-style": { cursor: "pointer" },
                              "header-cell-style": {
                                background: "#f9f9f9",
                                color: "#333333",
                                fontWeight: "500"
                              }
                            },
                            on: { "row-click": _vm.handleClickRow }
                          },
                          [
                            _c("el-table-column", {
                              attrs: {
                                label: "邮箱/手机号",
                                prop: "targetId",
                                "show-overflow-tooltip": ""
                              }
                            }),
                            _c("el-table-column", {
                              attrs: {
                                label: "名称",
                                prop: "userName",
                                "show-overflow-tooltip": ""
                              }
                            }),
                            _c("el-table-column", {
                              attrs: {
                                label: "部门",
                                prop: "groupNames",
                                "show-overflow-tooltip": ""
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      {
                        staticClass: "page-flex-end",
                        staticStyle: {
                          padding: "30px 0",
                          position: "relative"
                        },
                        attrs: { span: 24 }
                      },
                      [
                        _c("el-pagination", {
                          attrs: {
                            "current-page": _vm.filterModel.itemPage,
                            "page-sizes": [10, 20, 50, 100],
                            "page-size": _vm.filterModel.pageSize,
                            layout: "sizes, prev, pager, next, total",
                            total: _vm.filterModel.pageTotal
                          },
                          on: {
                            "size-change": _vm.handleSizeChange,
                            "current-change": _vm.handleCurrentChange
                          }
                        }),
                        _c("el-go", {
                          staticStyle: { right: "0" },
                          attrs: {
                            "page-size": _vm.filterModel.pageSize,
                            total: _vm.filterModel.pageTotal
                          },
                          on: { "current-change": _vm.handleCurrentChange }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini" },
                  on: {
                    click: function($event) {
                      _vm.visibleDialogSelectCopy = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.handleSelectCopyOk()
                    }
                  }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c("select-pup", {
        ref: "choosePupREF",
        attrs: {
          ChooseDialogVisible: _vm.ChooseDialogVisible,
          selectUsers: _vm.approvalModel.selectUsers
        },
        on: {
          "update:ChooseDialogVisible": function($event) {
            _vm.ChooseDialogVisible = $event
          },
          "update:choose-dialog-visible": function($event) {
            _vm.ChooseDialogVisible = $event
          },
          handleSelectUser: _vm.handleSelectUser
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-65c7cf14", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65c7cf14","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/console/Approval.vue
// module id = huwt
// module chunks = 102